import React, { lazy } from 'react'
import ComponentLoader from './component-loader'

const RegisterPassFormGrothtool = ComponentLoader(
  lazy(() => import('screens/public/register-new-pass-growthtool'))
)
const RegisterPassFormCampaign = ComponentLoader(
  lazy(() => import('screens/public/register-new-pass'))
)

const Pass = ComponentLoader(lazy(() => import('screens/public/Pass')))

const PassGrowthTool = ComponentLoader(
  lazy(() => import('screens/public/Pass-growthtool'))
)

// NEWSFEED
const NewsFeed = ComponentLoader(lazy(() => import('screens/public/newsfeed')))


// CAMPAIGN STUDIO v2 — customer join page (TASK-067)
const StudioJoin = ComponentLoader(lazy(() => import('screens/public/studio-join')))
// TASK-083: peer recognition
const StudioRecognise = ComponentLoader(lazy(() => import('screens/public/studio-recognise')))
// TASK-078: QR self check-in
const StudioCheckin = ComponentLoader(lazy(() => import('screens/public/studio-checkin')))

// TASK-056: GoHighLevel integration pages removed.

const PublicRoutes = [
  {
    path: 'registration',
    children: [
      {
        path: 'tool/:growthtool_code',
        element: <RegisterPassFormGrothtool />,
      },
      {
        path: 'citypass/:growthtool_code/:campaign_code',
        element: <RegisterPassFormCampaign />,
      },
      {
        path: 'tool/:growthtool_code/:campaign_code',
        element: <RegisterPassFormCampaign />,
      },
    ],
  },
  {
    path: 'customer/pass/:pass_code',
    element: <Pass />,
  },
  {
    path: 'tool/:growthtool_code/user/:user_code',
    element: <PassGrowthTool />,
  },
  {
    path: 'public/newsfeed',
    element: <NewsFeed />,
  },
  {
    path: 'join/:growthtool_code',
    element: <StudioJoin />,
  },
  {
    path: 'checkin/:code',
    element: <StudioCheckin />,
  },
  {
    path: 'recognise/:campaign_code',
    element: <StudioRecognise />,
  },
]

export default PublicRoutes
